export const GET_ALL_CHAT_NOTIFICATIONS = 'get_all_new_notifications'
export const GET_ALL_NEW_CHAT_NOTIFICATIONS = 'get_all_notifications'
export const GET_ALL_ORG_NOTIFICATIONS = 'get+all_org_notifications'
